import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {Spin, Empty} from 'antd';
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import useUserStore from "../../../stores/store";
import RecipeAddEditComponent from "../../../component/inventory/recipe/RecipeAddEditComponent";
import ApiService from "../../../utils/ApiService";
import { prepareFormattedAddOns } from "../../../services/inventory/recipe.service";

export default function RecipeEdit() {
  const { user, showNotification } = useUserStore();
  const navigate = useNavigate();
  const { recipeId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const recipeType = searchParams.get("recipeType");
  const variantId = searchParams.get("variantId");
  const [recipe, setRecipe] = useState({});
  const [recipeLoading, setRecipeLoading] = useState(true);

  async function getRecipeDetails(params) {
    if (!params) return;
    if (!params.hasOwnProperty("recipeId")) {
      console.error("Recipe id is required for getting recipe list.");
      return;
    }
    if (!params.hasOwnProperty("recipeType")) {
      console.error("Recipe type is required for getting recipe list.");
      return;
    }
    try {
      const res = await ApiService.GET_INVENTORY_RECIPE_DETAIL(params, user.token.token);
      if (res.code !== 200) {
        showNotification(res.data.message);
        setRecipeLoading(false);
        return;
      }
      const { payload } = res;
      const { record } = payload;
      const { options } = record;
      setRecipe(getRecordToRecipe(record));
      setRecipeLoading(false);
    } catch (err) {
      setRecipeLoading(false);
      showNotification(err.response.data.message);
      return;
    }
  }

  function getRecordToRecipe(record) {
    if (Object.keys(record).length < 1) return;
    const { options, addOns } = record;

    return {
      ...record,
      isDiscountInPercent: record.isDiscountInPercent ? "Yes" : "No",
      addOns: prepareFormattedAddOns(addOns),
      options: options.map((op) => ({
        ...op,
        name: ['System Default', 'Default'].includes(op.name) ? "" : op.name,
        isProfitInPercent: op.isProfitInPercent ? "Yes" : "No",
        ingredients: op.ingredients.map((ingredient) => ({
          ...ingredient,
          ingredientName: ingredient.ingredientId,
        })),
      })),
    };
  }

  useEffect(() => {
    if (Boolean(recipeId) && Boolean(recipeType)) {
      const params = { recipeId, recipeType, optionId: variantId };
      getRecipeDetails(params);
    }
  }, [recipeId, recipeType, variantId]);

  return (
    <div className="flex flex-col">
      {/* <CustomLoader /> */}
      <Header title={`McDonalds Food Chains`} menu={constants.MENU.INVENTORY} currentMenuKey={"T_7_S_7_L_5"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.INVENTORY} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="flex items-center justify-between">
              <h1 className="pt-[26px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
                Edit Recipe
              </h1>
              <button
                className="w-[100px] h-[48px] bg-[#FCBD10] rounded-[5px] text-black font-bold leading-[15px] leading-[17px]"
                onClick={() => navigate("/inventory/recipe")}
              >
                List
              </button>
            </div>

            <div>
              {recipeLoading ? (
                <div className="h-[50vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              ) : !Boolean(recipe) && Object.keys(recipe).length < 1 ? (
                <div className="h-[50vh] flex items-center justify-center">
                  <Empty />
                </div>
              ) : (
                <div>
                  <RecipeAddEditComponent data={recipe} currentSelectedVarId={variantId} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
